import React, { useState, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button,
    ButtonGroup,
    Form,
    CustomInput,
    FormGroup,
} from 'reactstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Separator, Colxx } from '../../../../../components/common/CustomBootstrap';
import Tooltip from './Tooltip';
export default function FacebookInfo({
    integration,
    integrationProperties,
    allProperties
}) {
    const [formatedProperties, setFormatedProperties] = useState([]);
    useEffect(() => {
        const result = integrationProperties.map(id => {
            return allProperties.find(elem => elem.id === id);
        });
        setFormatedProperties(result);
    }, [integrationProperties, allProperties]);

    const groupName = formatedProperties?.[0]?.groupName != null && formatedProperties?.[0]?.groupName != undefined ? formatedProperties[0].groupName : '';

    const styles = `
    .integration-title {
    color: #777 !important;
    }
   `;

    return (
        <Card className="mb-4">
            <style>{styles}</style>
            <CardBody>
                <div className="text-center">
                    <h6>
                        <IntlMessages id='integration.select_properties' />
                    </h6>
                    <Separator className="mb-3" />
                    <Card className="m-4">
                        <Colxx xxs="12" className="mt-2 py-3">
                            <div className="mb-2">
                                <h1 className='integration-title p-0'>{integration ? integration.name : null}</h1>
                                <div className="mb-3">
                                    <h6>Integration</h6>
                                    <div className="mb-2 container">
                                        <b>{integration ? integration.name : null} </b>
                                        <span className="text-muted pl-1">
                                            ({integration ? integration.id : null})
                                        </span>
                                        {integration?.id &&
                                            <div
                                                style={{ cursor: 'pointer', color: 'grey' }}
                                                onClick={() => {
                                                    navigator.clipboard.writeText(integration.id);
                                                }}
                                            >
                                                {' '}
                                                <i className='iconsminds-file-copy'></i>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <h6>Group</h6>
                                    <div className="mb-2 container">
                                        <b> {groupName}  </b>{' '}
                                        <span className="text-muted pl-1">
                                            ({integration ? integration.groupId : null})
                                        </span>
                                        {integration?.groupId &&
                                            <div
                                                style={{ cursor: 'pointer', marginLeft: 5, color: 'grey' }}
                                                onClick={() => {
                                                    navigator.clipboard.writeText(integration.groupId);
                                                }}
                                            >
                                                {' '}
                                                <i className='iconsminds-file-copy'></i>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <h6>Properties</h6>
                                    <div className="mb-2 container">
                                        {formatedProperties
                                            ? formatedProperties.map((elem, index) => {
                                                return (
                                                    <div key={index} className="mb-2  container">
                                                        <b>{elem ? elem.name : null}</b>{' '}
                                                        <span className="text-muted pl-1">
                                                            ({elem ? elem.id : null})
                                                        </span>
                                                        {elem?.id &&
                                                            <div
                                                                style={{ cursor: 'pointer', marginLeft: 5, color: 'grey' }}
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(elem?.id);
                                                                }}
                                                            >
                                                                {' '}
                                                                <i className='iconsminds-file-copy'></i>
                                                            </div>
                                                        }
                                                    </div>
                                                );
                                            })
                                            : null}
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <h6>Phone number</h6>
                                    <div className="mb-2 container">
                                        <span className="text-muted pl-1">
                                            ({integration?.channelDetails?.phoneNumber ? integration.channelDetails.phoneNumber : null})
                                        </span>
                                        {integration?.channelDetails?.phoneNumber &&
                                            <div
                                                style={{ cursor: 'pointer', marginLeft: 5, color: 'grey' }}
                                                onClick={() => {
                                                    navigator.clipboard.writeText(integration?.channelDetails?.phoneNumber);
                                                }}
                                            >
                                                {' '}
                                                <i className='iconsminds-file-copy'></i>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Colxx>
                    </Card>
                </div>
            </CardBody>
        </Card>
    );
}